'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FilebankService = exports.FilebankService = function () {
    function FilebankService(winresCloudService, $q) {
        _classCallCheck(this, FilebankService);

        this.winresCloudService = winresCloudService;
        this.$q = $q;
    }

    _createClass(FilebankService, [{
        key: 'getConfig',
        value: function getConfig() {
            var req = this.winresCloudService.get(this.endpoint() + '/Config');
            return req.then(function (result) {
                return result.data;
            }).catch(function (error) {
                console.error('[FilebankService getConfig] Error:', error);
                throw error; // Re-throw
            });
        }
    }, {
        key: 'getDestinationImages',
        value: function getDestinationImages(destinationCode) {
            var req = this.winresCloudService.get(this.destinationImages(destinationCode));
            return req.then(function (result) {
                // console.log('[FilebankService getDestinationImages] Success:', result);
                return result.data;
            }).catch(function (error) {
                console.error('[FilebankService getDestinationImages] Error:', error);
                return []; // Return empty list for now
            });
        }

        // By default, PUT will overwrite any existing file with the same name.
        // The _askToOverwrite_ callback can be provided to change this.
        // The callback should return a boolean, or a promise resolving to a boolean.
        //
        // This function returns a promise.
        //
        // - If the file was uploaded, the promise resolves to the returned
        //   PublicFile structure.
        //
        // - If there was a conflict and the user was asked and chose not to
        //   overwrite, the promise resolves to null.
        //
        // - If there was an error, including a conflict where the user was not
        //   asked what to do, the promise fails with the error returned by $http.

    }, {
        key: 'putDestinationImage',
        value: function putDestinationImage(destinationCode, name, file, askToOverwrite) {
            var _this = this;

            var config = {
                data: file,
                headers: {
                    'Content-Type': 'application/octet-stream'
                }
            };

            if (askToOverwrite) {
                // When request includes If-None-Match, the request is not performed if
                // the existing resource (e.g. old image) matches the provided ETag.
                // The value * matches any resource.
                // So, providing If-None-Match: * is equivalent to saying "do not overwrite".
                config.headers['If-None-Match'] = '*';
            }

            var req = this.winresCloudService.request('PUT', this.destinationImage(destinationCode, name), config);

            return req.then(function (result) {
                console.log('[FilebankService putDestinationImage] Success:', result);
                return result.data;
            }).catch(function (error) {
                if (_.isFunction(askToOverwrite) && error.status == 412) {
                    return _this.$q.resolve(askToOverwrite()).then(function (answer) {
                        if (answer) {
                            return _this.putDestinationImage(destinationCode, name, file, null);
                        } else {
                            return null;
                        }
                    });
                } else {
                    console.error('[FilebankService putDestinationImage] Error:', error);
                    throw error; // Re-throw
                }
            });
        }
    }, {
        key: 'deleteDestinationImage',
        value: function deleteDestinationImage(destinationCode, name) {
            var url = this.destinationImage(destinationCode, name);
            var config = { responseType: 'blob' }; // Avoid (Firefox?) bug with empty responses
            return this.winresCloudService.delete(url, config);
        }
    }, {
        key: 'endpoint',
        value: function endpoint() {
            return 'Filebank';
        }
    }, {
        key: 'destination',
        value: function destination(destinationCode) {
            return this.endpoint() + '/Destinations/' + destinationCode;
        }
    }, {
        key: 'destinationImages',
        value: function destinationImages(destinationCode) {
            return this.destination(destinationCode) + '/Images';
        }
    }, {
        key: 'destinationImage',
        value: function destinationImage(destinationCode, fileName) {
            return this.destinationImages(destinationCode) + '/' + fileName;
        }
    }]);

    return FilebankService;
}();

FilebankService.$inject = ['winresCloudService', '$q'];


//////////////////
// WEBPACK FOOTER
// ./src/winresCloud/filebankService.js
// module id = 575
// module chunks = 2